module.exports = __webpack_public_path__ + "static/img/toujiao_bg.f7f12f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao_bg.png
// module id = ducE
// module chunks = 1